import apiClient from 'services/_infra/apiClient';
import { loginfo } from 'services/_infra/util/apiUsageLogger';

export async function getCityStateFromCoordinates(lat, lon) {
  try {
    loginfo();
    return await apiClient.get('/location/city-state', {
      params: { lat, long: lon },
    });
  } catch (error) {
    console.error('getCityandStateAtCoordinate failed.', error);
  }
}

export async function autoCompleteSearch(latitude, longitude, term) {
  try {
    loginfo();
    return await apiClient.get('/location/google/autocomplete', {
      params: { lat: latitude, long: longitude, term },
    });
  } catch (error) {
    console.error('googleAutocompleteSearch failed.', error);
    throw error;
  }
}

// CW-validated autocomplete: same Google candidates, but each result is
// annotated with the CW `city_id` it resolves to plus `cwConfirmed` /
// `cwSource`, so the setup / new-location finder can flag picks that
// won't populate weather data. Used by the places finder when the
// `cwValidated` flag is set.
export async function cwAutoCompleteSearch(latitude, longitude, term) {
  try {
    loginfo();
    return await apiClient.get('/location/google/cwautocomplete', {
      params: { lat: latitude, long: longitude, term },
    });
  } catch (error) {
    console.error('googleCWAutocompleteSearch failed.', error);
  }
}

export async function informLocationChange(location) {
  try {
    loginfo();
    return await apiClient.post('/location/dashboard-locations/touch', { location });
  } catch (error) {
    console.error('informLocationChange failed.', error);
  }
}

export async function connectToIsDataReadyForLocation(location) {
  // Defensive: a saved/normalized place may lack place_data or a country
  // component. Don't throw (that would silently kill the subscribe) — the
  // backend resolves city_ids by city/state and only uses country as metadata.
  const country =
    location.place_data?.address_components?.find((item) => item.types?.includes('country'))
      ?.short_name ?? '';

  const locationInfo = {
    city: location.city,
    state_long: location.state_long,
    term: location.term,
    latitude: location.latitude,
    longitude: location.longitude,
    country: country,
  };
  try {
    loginfo();
    const url = `${process.env.PUBLIC_API_URL}/location/dashboard-locations/subscribe?location=${encodeURIComponent(JSON.stringify(locationInfo))}`;

    return new EventSource(url, { withCredentials: true });
  } catch (e) {
    throw e;
  }
}
